// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"32ef0b6036c5d927","3525":"65571ea96a98a839","5381":"8c68d6113632810f","7406":"8c68d6113632810f","9568":"bf3b217b7955ee0e"}[chunkId] + ".css";
};